module.exports = __webpack_public_path__ + "static/media/postman.dd1332ff.svg";